import { ReactElement, useState } from 'react';
import ServicesPanel from './ServicesPanel';
import ContainerPadded from './ContainerPadded';

export default function Parking() {
    const [open, setOpen] = useState('1');

    return (
        <ContainerPadded>
            <div className="container">
                <div className='row'>
                    <div className='services-panel p-2 card w-75 mx-auto'>
                        <div className='card-body'>
                            <h1>Commercial Truck Parking Lot in Albany GA coming soon!</h1>
                            <ul className='mt-4'>
                                <li>3 acre lot on Sylvester Hwy</li>
                                <li>Clean, gated, and well lit</li>
                                <li>Short term and long term rental options available</li>
                                <li>Call 229-352-2627 or email <a href="mrevell@revelllogistics.com">mrevell@revelllogistics.com</a> for pricing</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </ContainerPadded>
    );
}
